import VueRouter, { RouteConfig } from 'vue-router'

const Index = () => import('../activity/exam-2023/Index.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/exam-2023',
  name: 'activity_exam_2023',
  component: Index,
  meta: {
    title: '体测专项提升计划',
    ignoreLogin: true,
  },
}

export default [indexRoute]

export function navigateToExam2023Activity(router: VueRouter) {
  router.push({ name: indexRoute.name })
}
